import { render, staticRenderFns } from "./AppDataTableComponent.vue?vue&type=template&id=48eca11b&scoped=true"
import script from "./AppDataTableComponent.vue?vue&type=script&lang=js"
export * from "./AppDataTableComponent.vue?vue&type=script&lang=js"
import style0 from "./AppDataTableComponent.vue?vue&type=style&index=0&id=48eca11b&prod&scoped=true&lang=css"
import style1 from "./AppDataTableComponent.vue?vue&type=style&index=1&id=48eca11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eca11b",
  null
  
)

export default component.exports